import { request } from "utils/api";

// import user data
export interface ImportUserData {
    email: string,
    firstName: string,
    lastName: string,
    site?: string;
}

// import a list of users (POST /admin/import)
export const postImport = (data: {
    clubId: string,
    users: ImportUserData[],
}) => request<{
    addedToClub: ImportUserData[],
    alreadyClubMembers: ImportUserData[],
    createdAccounts: ImportUserData[],
}>({
    data,
    endpoint: "/admin/import",
    method: "post",
});
